<div
  class="hot-toast-warning-icon"
  [style.--warn-primary]="theme()?.primary"
  [style.--warn-secondary]="theme()?.secondary"
></div>
